var map = {
	"./collection-filter-bar.vue": 6113,
	"./collection-filter.vue": 3656,
	"./collection-grid.vue": 7044,
	"./collection-highlilghted-products.vue": 7982,
	"./collection-load-more.vue": 6878,
	"./collection-setup.vue": 703
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9432;